import React, { PropsWithChildren } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';

import { theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const HomeCategory = (props: PropsWithChildren) => {
  const { children } = props;

  const { currentBreakpoint } = useResponsive();

  // ───────────────────────────────────────────────────────────────────────────

  if (currentBreakpoint.isXS) {
    return <HomeCategoryScrollView>{children}</HomeCategoryScrollView>;
  }

  return <HomeCategoryFlexView>{children}</HomeCategoryFlexView>;
};

const HomeCategoryScrollView = (props: PropsWithChildren) => {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={styles.scrollView}
    >
      {props.children}
    </ScrollView>
  );
};

const HomeCategoryFlexView = (props: Pick<ViewProps, 'style' | 'children'>) => {
  return <View style={[styles.flexView, props.style]}>{props.children}</View>;
};

HomeCategory.ScrollView = HomeCategoryScrollView;
HomeCategory.FlexView = HomeCategoryFlexView;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  scrollView: {
    gap: theme.spacing['6'],
  },
  flexView: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing['6'],
  },
});
